export default function CTernary() {
  return <h2>C Ternary</h2>;
}
